import type { AuthUser } from '@repo/shared-types';
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import { useAuthStore } from '@/stores/auth.store';

interface MeResponse {
  user: AuthUser;
  token: string;
  expiresAt: string;
}

export function useMe() {
  const token = useAuthStore((s) => s.token);
  const hydrated = useAuthStore((s) => s._hasHydrated);

  return useQuery({
    queryKey: ['auth', 'me'] as const,
    queryFn: async () => {
      const data = await apiFetch<MeResponse>('/auth/me');
      useAuthStore.getState().setSession({ token: data.token, user: data.user });
      return data;
    },
    enabled: hydrated && Boolean(token),
    staleTime: 60_000,
    retry: (failureCount, err) => {
      if (err && typeof err === 'object' && 'status' in err && err.status === 401) {
        return false;
      }
      return failureCount < 2;
    },
  });
}
